import RevealPill, { PillSwitch } from '@/components/Editor/Form/fields/RevealPill';
import { jsx as _jsx } from "react/jsx-runtime";

const EditorFieldsZeroBaselineToggle = _ref => {
  let {
    label = 'Start From Zero',
    forceZeroBaseline = false,
    openButtonVariant,
    onChange
  } = _ref;
  return /*#__PURE__*/_jsx(RevealPill, {
    label: label,
    disableOpen: true,
    openButtonVariant: openButtonVariant,
    activeState: /*#__PURE__*/_jsx(PillSwitch, {
      checked: forceZeroBaseline,
      onChange: checked => onChange({
        forceZeroBaseline: checked
      })
    })
  });
};

export default EditorFieldsZeroBaselineToggle;